import React from "react";

export default function BracketGameDetails({
 existingGame,
 topValue,
 gameDetailsTextColor,
}) {
 if (!existingGame) return null;

 return (
  <div
   className="game-details-bar"
   style={{
    position: "absolute",
    left: 0,
    right: 0,
    margin: "0 auto",
    width: "98%",

    // Align bottom of details bar above match box
    top: topValue - 4,
    transform: "translateY(-100%)",

    fontSize: "11px",
    textAlign: "center",
    color: gameDetailsTextColor,
    borderRadius: 7,
    zIndex: 2,
    fontWeight: 500,
    padding: "2px 0",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "8px",
    pointerEvents: "auto",
   }}
  >
   {/* Location */}
   <span>
    {existingGame.location_url ? (
     <a
      href={existingGame.location_url}
      target="_blank"
      rel="noopener noreferrer"
      style={{
       color: "#0074D9",
       textDecoration: "none",
       fontWeight: 600,
      }}
      onClick={(e) => e.stopPropagation()}
     >
      📍 {existingGame.location}
     </a>
    ) : (
     <>📍 {existingGame.location}</>
    )}
   </span>

   {/* Date */}
   <span>
    {new Date(
     `${existingGame.date}T${existingGame.time || "00:00"}`
    ).toLocaleDateString("en-US", {
     month: "short",
     day: "numeric",
     year: "numeric",
    })}
   </span>

   {/* Time */}
   <span>
    {new Date(
     `1970-01-01T${existingGame.time || "00:00"}`
    ).toLocaleTimeString("en-US", {
     hour: "numeric",
     minute: "2-digit",
     hour12: true,
    })}
   </span>
  </div>
 );
}